var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 21H8.00047C7.73525 21 7.4809 20.8946 7.29336 20.7071C7.10583 20.5196 7.00047 20.2652 7.00047 20V12.07L5.70047 13.07C5.31047 13.46 4.68047 13.46 4.29047 13.07L1.46047 10.29C1.07047 9.9 1.07047 9.27 1.46047 8.88L7.34047 3H9.00047C9.00047 4.1 10.3405 5 12.0005 5C13.6605 5 15.0005 4.1 15.0005 3H16.6605L22.5405 8.88C22.9305 9.27 22.9305 9.9 22.5405 10.29L19.7105 13.12C19.3205 13.5 18.6905 13.5 18.3005 13.12L17.0005 12.12V20C17.0005 20.2652 16.8951 20.5196 16.7076 20.7071C16.52 20.8946 16.2657 21 16.0005 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.a8ab7d0e46c6c581287dbe569d0fcfc7.svg";
export { ForwardRef as ReactComponent };